import layout from '@/layout/index.vue'
export default {
  name: 'group-spm-order',
  meta: { title: '订单查询', icon: 'icon-order' },

  children: [
    {
      name: 'spm-order',
      meta: { title: '订单查询', icon: 'icon-order' },

      routers: [
        {
          path: '/order',
          name: 'order',
          component: layout,
          children: [
            {
              path: 'index',
              name: 'index',
              component: () => import('@/views/order/index.vue'),
              meta: { title: '订单查询', vPermission: ['pc-bar-order:order'] }
            }
          ]
        }
      ]
    }
  ]
}
